import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import leftPad from 'left-pad';

import apiCall from '../apiCall';

import { icons } from '../../assets/assets';
import actions from '../../actions';
import PopupTitle from "../elements/PopupTitle";
import {dispatchUnreadPopup, getPopupDeviceDifficulty} from "../../helpers/popupHelper";
import imageResizer from '../../helpers/imageResizer';

const { addPhoto, removePhoto } = actions.schoolClass;

class Pictures extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.deviceAndDifficulty = getPopupDeviceDifficulty(this.props.gameState.DefaultDifficultyId);
  }

  componentDidMount(){
    const { dispatch, gameState } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if(currentRound <= 1) {
      dispatchUnreadPopup((gameState.difficulty === "PRO" ? 'mhbvtfotos_T' : 'mlbvtfotos_T'), dispatch);
    }
  }

  upload = async (files) => {
    const formData = new FormData();
    // eslint-disable-next-line
    let localLastUploadName = false;
    let maxUploads = 20 - this.props.schoolClass.SchoolClassPhotos.length;
    const lastPhotoUploaded = this.props.schoolClass.SchoolClassPhotos[this.props.schoolClass.SchoolClassPhotos.length - 1];
    let newPhotoNum = lastPhotoUploaded && lastPhotoUploaded.Photo && lastPhotoUploaded.Photo.filename && !isNaN(parseInt(lastPhotoUploaded.Photo.filename.split('-')[1], 10)) ? parseInt(lastPhotoUploaded.Photo.filename.split('-')[1], 10) : 0;
    await Object.keys(files).map(async fileKey => {
      const file = files[fileKey];
      if (file && file.name) {
        if(maxUploads <= 0) {
          return;
        }
        maxUploads--;
        newPhotoNum++;
        const fileName = `B-${leftPad(newPhotoNum, 2, 0)}-${this.props.schoolClass.className}-${this.props.schoolClass.classRoom}`.replace(/[^a-z0-9]/gi, '_') + '.jpeg';
        const resized = await imageResizer(file, 1200, 1200, 0.8, fileName);
        formData.append('file', resized, resized.name);
        await apiCall('/file/upload', formData, 'POST')
          .then((f) => {
            localLastUploadName = fileName;
            this.props.dispatch(addPhoto(this.props.schoolClass.id, {
              PhotoId: f[0].id,
            }));
          });
      }
    })
  };

  render() {
    const { schoolClass } = this.props;
    if (!schoolClass.loaded) return null;
    return (
      <div className={this.props.desktop ? 'portal-home darkBckg' : ''}>
        <div className={`pictures pictures-view`}>
          <div className={'container classleader-portal'}>
            <div className={'title-block'}>
              <PopupTitle popupId={`${this.deviceAndDifficulty}bvtfotos`} tag={'h3'}/>
            </div>
            <div className="photos-container">
              {
                schoolClass.SchoolClassPhotos.map((photo, i) => {
                  return (
                    <div className="photo" key={photo.id}>
                      <div className="photo-wrapper">
                        <div className="trash-button" onClick={() => {
                          if (window.confirm(__('sim_bevestig_verwijder_photo_melding'))) {
                            this.props.dispatch(removePhoto(photo.id));
                          }
                        }}>
                          <img src={icons.trash} alt="trash" />
                        </div>
                        <div className="img-wrapper">
                          <img src={photo.Photo.url} alt="afbeelding" />
                        </div>
                      </div>
                      <span>{photo.Photo.filename}</span>
                    </div>
                  );
                })
              }
            </div>
            <div style={{
              position: 'fixed',
              bottom: '20px',
              left: 0,
              right: 0,
            }}>
              {
                schoolClass.SchoolClassPhotos.length < 20
                  ? (
                    <div className="upload-container">
                      <div className="upload-container-inner">
                        <button>
                          <span>{__('sim_upload')}</span>
                        </button>
                        <input
                          type={'file'}
                          name={'photo'}
                          accept="image/png,image/jpeg"
                          multiple={true}
                          onChange={(e) => {
                            this.upload(e.target.files);
                          }}
                        />
                      </div>
                    </div>
                  )
                  : null
              }
              <p className="warning-message">{__('sim_fotos_let_op_maximaal_fotos')}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  schoolClass: state.schoolClass,
  gameState: state.gameState,
}))(Pictures);



// WEBPACK FOOTER //
// ./src/components/elements/Pictures.js